export const EPISODES_CALL_REQUEST = "EPISODES_CALL_REQUEST";
export const EPISODES_CALL_SUCCESS = "EPISODES_CALL_SUCCESS";
export const EPISODES_CALL_FAILURE = "EPISODES_CALL_FAILURE";
